import React, { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { animated, useSpring } from '@react-spring/web';
import { Text, TextVariant } from '@naf/text';
import { breakpoints, spacing } from '@naf/theme';
import { formatNumberWithSpaces } from '@lib/formatNumberWithSpaces';
import { StatisticsType } from '../../../../../../types/keyStatisticsBlockType';

type AnimatedCounterProps = { item: StatisticsType };

export const AnimatedCounter = ({ item }: AnimatedCounterProps) => {
  const [triggerCount, setTriggerCount] = useState<boolean>(false);
  const counterRef = useRef<HTMLSpanElement | null>(null);

  const targetNumber = +item.number;

  const { value } = useSpring({
    value: triggerCount ? targetNumber : 0,
    from: { value: 0 },
    config: { frequency: 1, damping: 1 },
  });

  useEffect(() => {
    if (typeof window !== 'undefined' && counterRef?.current) {
      const counterObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries && entries.length > 0 ? entries[0] : null;
          if (entry && entry.isIntersecting) {
            setTriggerCount(true);
          } else if (entry) {
            setTriggerCount(false);
          }
        },
        { threshold: [0, 1] },
      );

      counterObserver.observe(counterRef.current);
    }
  }, []);

  return (
    <ItemWrapper>
      <StyledHeader tag="p" variant={TextVariant.SubHeader}>
        <animated.span ref={counterRef}>
          {value.to((val) => formatNumberWithSpaces(Math.floor(val as number)))}
        </animated.span>
      </StyledHeader>
      <StyledText key={`${item._key}_${item.subtitle}`} tag="p" variant={TextVariant.Tag}>
        {item.subtitle}
      </StyledText>
    </ItemWrapper>
  );
};

const StyledHeader = styled(Text)`
  font-size: 3rem;
  margin-top: 0;
  margin-bottom: ${spacing.space24};
  @media (max-width: ${breakpoints.s}) {
    font-size: 2rem;
  }
`;

const StyledText = styled(Text)`
  margin: 0;
`;

const ItemWrapper = styled.div`
  min-width: 20%;
  text-align: center;
  margin: ${spacing.space48} 0;
  @media (max-width: ${breakpoints.m}) {
    min-width: 33.3333333%;
  }
`;
